<ng-container *ngIf="dataService.prodotto">

  <mat-toolbar [ngClass]="setClass()">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlexFill>
      <div class="icona-offerta" fxLayoutAlign="start center">
        <ng-container *ngIf="dataService.prodotto.cod_tipo_fornitura_id != 'GAS'">
          <img src="../../assets/imgs/icona-luce.png">
        </ng-container>
        <ng-container *ngIf="dataService.prodotto.cod_tipo_fornitura_id != 'EE'">
          <img src="../../assets/imgs/icona-gas.png">
        </ng-container>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="logo">
        <span>Offerta {{dataService.prodotto.des_prodotto}}</span>
        <img src="../../assets/imgs/logo.png" alt="logo">
      </div>
    </div>
  </mat-toolbar>

  <mat-horizontal-stepper [linear]="_environment.linear" (selectionChange)="event($event)">
    <mat-step [editable]="!confermato" [stepControl]="datiAnagrafici.datiAnaForm">
      <ng-template matStepLabel>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pre-arrow-right" fxLayoutAlign="center center">
            Dati anagrafici
          </div>
          <div class="arrow-right"></div>
        </div>
      </ng-template>
      <div fxLayout="row" fxLayoutAlign="end" class="step-buttons-top">
        <button [disabled]="!datiAnagrafici.datiAnaForm.valid" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="datiAnagrafici.datiAnaForm.valid">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <app-dati-anagrafici #datiAnagrafici></app-dati-anagrafici>
      <ng-container *ngIf="!datiAnagrafici.datiAnaForm.valid">
        <div fxLayoutAlign="end center">
          <mat-error>
            * Compilare i campi correttamente per continuare
          </mat-error>
        </div>
      </ng-container>
      <div fxLayout="row" fxLayoutAlign="end" class="step-buttons-bottom">
        <button [disabled]="!datiAnagrafici.datiAnaForm.valid" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="datiAnagrafici.datiAnaForm.valid">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-step>
    <mat-step [editable]="!confermato" [stepControl]="datiFornitura.datiFornForm">
      <ng-template matStepLabel>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pre-arrow-right" fxLayoutAlign="center center">
            Dati di fornitura
          </div>
          <div class="arrow-right"></div>
        </div>
      </ng-template>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-top">
        <button mat-raised-button matStepperPrevious color="primary">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
        <button [disabled]="!datiFornitura.datiFornForm.valid || datiFornitura.richieste.length < 1" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="!datiFornitura.datiFornForm.valid || datiFornitura.richieste.length < 1">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <app-dati-fornitura #datiFornitura [datiAnaForm]="datiAnagrafici.datiAnaForm" [datiFirmaForm]="datiFirma.datiFirmaForm"></app-dati-fornitura>
      <ng-container *ngIf="!datiFornitura.datiFornForm.valid">
        <div fxLayoutAlign="end center">
          <mat-error>
            * Compilare i campi correttamente per continuare
          </mat-error>
        </div>
      </ng-container>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-bottom">
        <button mat-raised-button matStepperPrevious color="primary">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
        <button [disabled]="!datiFornitura.datiFornForm.valid || datiFornitura.richieste.length < 1" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="!datiFornitura.datiFornForm.valid || datiFornitura.richieste.length < 1">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-step>
    <mat-step [editable]="!confermato" [stepControl]="datiPagamento.datiFattForm">
      <ng-template matStepLabel>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pre-arrow-right" fxLayoutAlign="center center">
            Pagamento e fatturazione
          </div>
          <div class="arrow-right"></div>
        </div>
      </ng-template>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-top">
        <button mat-raised-button matStepperPrevious color="primary">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
        <button [disabled]="!datiPagamento.datiFattForm.valid" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="!datiPagamento.datiFattForm.valid">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <app-pagamento-fatturazione #datiPagamento [datiAnaForm]="datiAnagrafici.datiAnaForm">
      </app-pagamento-fatturazione>
      <ng-container *ngIf="!datiPagamento.datiFattForm.valid">
        <div fxLayoutAlign="end center">
          <mat-error>
            * Compilare i campi correttamente per continuare
          </mat-error>
        </div>
      </ng-container>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-bottom">
        <button mat-raised-button matStepperPrevious color="primary">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
        <button [disabled]="!datiPagamento.datiFattForm.valid" mat-raised-button matStepperNext color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="!datiPagamento.datiFattForm.valid">
          Continua<mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-step>
    <mat-step [editable]="!confermato" [stepControl]="datiFirma.datiFirmaForm">
      <ng-template matStepLabel>
        <div fxLayout="row" fxLayoutAlign="center center">
          <div class="pre-arrow-right" fxLayoutAlign="center center">
            Firma e sottoscrizione
          </div>
          <div class="arrow-right"></div>
        </div>
      </ng-template>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-top">
        <button mat-raised-button matStepperPrevious color="primary" [disabled]="confermato">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
      </div>
      <app-firma-sottoscrizione #datiFirma [datiPagamento]="datiPagamento.datiFattForm" [disableFirmaVolture]="datiFornitura.disableFirmaVolture">
      </app-firma-sottoscrizione>
      <div fxLayout="row" fxLayoutAlign="space-between" class="step-buttons-bottom">
        <button mat-raised-button matStepperPrevious color="primary" [disabled]="confermato">
          <mat-icon>arrow_back</mat-icon>Precedente
        </button>
        <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
          <button mat-raised-button (click)="generaAnteprima()" [disabled]="confermato || datiFirma.datiFirmaForm.invalid" color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="confermato || datiFirma.datiFirmaForm.invalid">Genera Anteprima</button>
          <!-- <button mat-icon-button color="primary" class="button-open-in-new" matTooltip="Apri anteprima" fxLayoutAlign="center center" (click)="apriAnteprima()" [disabled]="!!!anteprimaBlob">
            <mat-icon>open_in_new</mat-icon>
          </button> -->

          <button [disabled]="confermato || datiFirma.datiFirmaForm.invalid" mat-raised-button matStepperNext (click)="conferma()" color="primary" matTooltip="Compila tutti i campi obbligatori" [matTooltipDisabled]="confermato || datiFirma.datiFirmaForm.invalid">Conferma</button>
          <ng-container *ngIf="confermato && datiFirma.datiFirmaForm.get('modalitaFirma')?.value == '2'">
            <button mat-raised-button matStepperNext class="button-open-in-new" matTooltip="Apri contratto" fxLayoutAlign="center center" color="primary" (click)="getContratto()">
              Contratto
              <mat-icon>open_in_new</mat-icon>
            </button>
          </ng-container>

        </div>
      </div>
      <!-- <ng-container *ngIf="confermato">
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
          <div>L'operazione è stata confermata, procedere con la firma del contratto</div>
          <mat-spinner color="primary" diameter="20" value="indeterminate">
          </mat-spinner>
        </div>
      </ng-container> -->
    </mat-step>
  </mat-horizontal-stepper>

</ng-container>
